import { api } from './client';
import type {
  BrandDto,
  CategoryBreadcrumbDto,
  CategoryDto,
  CollectionDto,
  PagedRequest,
  PagedResult,
  ProductDetailDto,
  ProductFacetsDto,
  ProductListItemDto,
  ProductQueryDto,
  ProductReviewCreateDto,
  ProductReviewDto,
  ReviewEligibilityDto,
  ReviewSummaryDto,
  ReviewVoteResultDto,
  SearchAutocompleteDto,
} from './types';

/* ------------------------------------------------------------------ *
 *  Vitrin katalogu — 15 uc
 *  /api/products (8), /api/categories (3), /api/brands (2),
 *  /api/collections (2)
 * ------------------------------------------------------------------ */

export const catalogApi = {
  /** 1. Filtreli ve sayfali urun listesi. */
  searchProducts: (query: ProductQueryDto = {}) =>
    api.get<PagedResult<ProductListItemDto>>('/api/products', query),

  /**
   * 2. Filtre panelinin secenekleri (marka, fiyat araligi, ozellikler).
   * Ayni sorguyla cagrilir; sayimlar aktif filtreye gore hesaplanir.
   */
  productFacets: (query: ProductQueryDto = {}) =>
    api.get<ProductFacetsDto>('/api/products/facets', query),

  /** 3. Urun detayi. Yalnizca yayindaki urunler doner. */
  productBySlug: (slug: string) => api.get<ProductDetailDto>(`/api/products/${slug}`),

  /** 4. Benzer urun onerileri. */
  relatedProducts: (productId: number, take = 8) =>
    api.get<ProductListItemDto[]>(`/api/products/${productId}/related`, { take }),

  /** 5. Urun yorumlari. */
  productReviews: (productId: number, query: PagedRequest = {}) =>
    api.get<PagedResult<ProductReviewDto>>(`/api/products/${productId}/reviews`, query),

  /** 6. Puan dagilimi ve ortalama. */
  reviewSummary: (productId: number) =>
    api.get<ReviewSummaryDto>(`/api/products/${productId}/reviews/summary`),

  /** 7. Yorum yapma uygunlugunu sorgular. */
  checkReviewEligibility: (productId: number) =>
    api.get<ReviewEligibilityDto>(`/api/products/${productId}/reviews/eligibility`),

  /** 8. Yorum birakir. Magaza ayarina gore satin alma sarti aranabilir. */
  createReview: (dto: ProductReviewCreateDto) =>
    api.post<ProductReviewDto>('/api/products/reviews', dto),

  /** 9. Yorumu faydali / faydasiz olarak isaretler veya oyu geri alir. */
  markReviewHelpful: (reviewId: number, helpful = true) =>
    api.post<ReviewVoteResultDto>(`/api/products/reviews/${reviewId}/helpful?helpful=${helpful}`),

  /** 9. Kategori agaci (menu ve gezinti icin). */
  categoryTree: () => api.get<CategoryDto[]>('/api/categories'),

  /** 10. Kategori detayi. */
  categoryBySlug: (slug: string) => api.get<CategoryDto>(`/api/categories/${slug}`),

  /** 11. Kategori kirilim yolu. */
  categoryBreadcrumbs: (id: number) =>
    api.get<CategoryBreadcrumbDto[]>(`/api/categories/${id}/breadcrumbs`),

  /** 12. Marka listesi. */
  searchBrands: (query: PagedRequest = {}) => api.get<PagedResult<BrandDto>>('/api/brands', query),

  /** 13. Marka detayi. */
  brandBySlug: (slug: string) => api.get<BrandDto>(`/api/brands/${slug}`),

  /** 14. Koleksiyon listesi. */
  searchCollections: (query: PagedRequest = {}) =>
    api.get<PagedResult<CollectionDto>>('/api/collections', query),

  /** 15. Koleksiyon detayi. */
  collectionBySlug: (slug: string) => api.get<CollectionDto>(`/api/collections/${slug}`),

  /** 16. Arama otomatik tamamlama (canlı öneriler, ürünler, kategoriler, markalar). */
  autocomplete: (q: string) => api.get<SearchAutocompleteDto>('/api/products/autocomplete', { q }),
};
